export default __webpack_public_path__ + "static/media/up.a4aca5de.svg";